import { useEffect, useState } from "react";

import api from "../api/client";

import { getUser } from "../store/authStore";

import {
  getSelectedClinicId,
} from "../store/selectedClinicStore";

export default function useReportsList() {

  const [reports, setReports] = useState([]);

  useEffect(() => {

    let url = "/api/reports/";

    const user = getUser();

    if (user?.role !== "clinic") {

      const clinicId = getSelectedClinicId();

      if (clinicId) {
        url += `?clinic_id=${clinicId}`;
      }
    }

    api.get(url)
      .then((res) => setReports(res.data))
      .catch((err) => {
        console.error("Ошибка загрузки списка отчетов:", err);
      });

  }, []);

  return { reports };
}
